import React from "react";
import * as Icons from "pickups-ui-library/styles/icons";
import { connect } from "react-redux";
import { compose } from "redux";

import { logoutUser } from "containers/Auth/actions";
import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from "reactstrap";
import { Dropdown } from "react-bootstrap";

import { NavLink, Link } from "react-router-dom";

const CustomToggle = React.forwardRef(({ user, ...props }, ref) => (
  <div className="user-dropdown" ref={ref} {...props}>
    <div className="user-dropdown-avatar">
      <div className="user-dropdown-avatar-icon">
        <img
          style={{ width: 48, height: 48, borderRadius: 45 }}
          src={user.profileImage}
          alt=""
        />
      </div>
    </div>
  </div>
));

const Navigation = ({ logoutUser, user, publicMode }) => (
  <Navbar
    color="white"
    className="box-bottom primary-navigation"
    light
    expand="false"
  >
    <NavbarBrand>
      <Link to={"/"}>
        <img
          style={{ maxWidth: "8em" }}
          src={`${process.env.REACT_APP_LOGO_URL}`}
        />
      </Link>
    </NavbarBrand>
    {publicMode ? (
      <div>
        <NavLink exact to="/login">
          Log In
        </NavLink>{" "}
      </div>
    ) : (
      <Dropdown>
        <Dropdown.Toggle
          as={CustomToggle}
          className="user-dropdown"
          user={user}
        />
        <Dropdown.Menu>
          <Dropdown.Item as={NavLink} exact to="/">
            Home
          </Dropdown.Item>
          <Dropdown.Item as={NavLink} exact to="/pickups">
            Pickups
          </Dropdown.Item>
          <Dropdown.Item as={NavLink} exact to="/tax-receipts">
            Tax Receipts
          </Dropdown.Item>
          <Dropdown.Item as={NavLink} exact to="/settings/account">
            Account Settings
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => {
              logoutUser();
            }}
            href="#"
          >
            Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )}
  </Navbar>
);

const mapStateToProps = (state) => ({
  router: state.router,
  user: state.user,
});

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    logoutUser: () => {
      dispatch(logoutUser());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(Navigation);
